export enum AgentRole {
  HR_AGENT_ADMIN = 'HRAgent_Admin',
  HR_AGENT_SUPERADMIN = 'HRAgent_SuperAdmin',
}

export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
}

export interface IUser {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  displayName: string;
  role: UserRole;
  refreshToken?: string;
}

export interface IUserPayload extends IUser {
  /** Issued At */
  iat?: number;
  /** Expiration Time */
  exp?: number;
}
